import React, {useContext,useState,useEffect} from "react";
import { useLocation } from 'react-router-dom'
import Context from '../context/context';
import Lang from '../lang/translations';
import { useForm  } from 'react-hook-form';
import Auth from '../../userServices/authServices';
import helpersFunction from "../_helpers/helpersFunction";

const config = require("../_helpers/configServizi");



export default function SignupForm(props) {


    console.log("DOIII",props)
    
	const  context = useContext(Context)
    const domain = window.location.hostname;

    const [formError, setFormError] = useState({email:false});
    const [spinner, setSpinner] = useState(false);
    const [errore, setErrore] = useState("");
    const [validMail, setvalidMail] = useState(true);
    const [formShow, setFormShow] = useState(true);
    const [changedEmail, setchangedEmail] = useState(null);
    const email = Lang( {"w": "cambia_mail","page": "doi_popup","var":true} )
    const msgOk = Lang( {"w": "messaggio_ok","page": "doi_popup"} )
    const bottoneForm = Lang( {"w": "invia","page": "doi_popup","var":true} )
	var location = useLocation();
	location = location.pathname.split("/")

    const { register, handleSubmit, control  } = useForm();

    function Spinner(){
		if(spinner){
			return (<div className="spinner-border text-light" role="status">
		  <span className="sr-only"><Lang w={"caricando"} page={"signupForm"}/></span>
		</div>);
		}else{
			return (<div></div>);
		}
	}

    function handleInputChange(target) {
		const value = target.currentTarget.value;
		if (target.currentTarget.name === "email") {
			value.length > 0 ? setFormError({...formError,email:false}) : setFormError({...formError,email:true})
		}

	}

    function campiVuoti(data){
        var tmpObj = formError
      
        data.email.length == 0 ? tmpObj.email=true : tmpObj.email= false
             
        setFormError(tmpObj)


		if(tmpObj.email){
			setErrore(Lang( {"w": "errore_email","page": "signupForm"} ));
			return true
		}

	
		return false
        
    }


    const onSubmit = (data) => {
		
		try{
            setSpinner(true);
			setErrore("");

			if(campiVuoti(data)){
				setSpinner(false);
				return
			}

            if(data.email == context.email){
                setErrore(Lang( {"w": "errore_stessa_mail","page": "doi_popup"} ));
                setSpinner(false);
				return
            }

            Auth.changeEmail(context.email,data.email,window.location.hostname)
			.then(res => {
                console.log("Cambio mail",res)
				if(res.result == "OK"){
					context.setUserEmail(res.user.email)
                    if(res.user.valid_email){
                        setFormShow(false);
                        setvalidMail(true)
                        setchangedEmail(res.user.email)
                    }else{
                        setchangedEmail(res.user.email)
                        setvalidMail(false)
                        setSpinner(false);
                    }
                     
				}else{
					setErrore(helpersFunction.errorCodes(res));
					setSpinner(false); 
				}
			}).catch(err => {
                setErrore(helpersFunction.errorCodes(err));
				setSpinner(false); 
            })

        }catch(err){

        }
    
    }


    useEffect(() => { 

        setvalidMail(props.contenuto.valid_email)
	
	},[props.contenuto.valid_email]);


    useEffect(() => { 

        helpersFunction.kpiPanel(context,"popup_doi","visualizzato")
	
	},[]);

    return(<>

        {props.contenuto.valid_email || validMail ? (<>
            <h2> <Lang w={"attiva_account"} page={"doi_popup"} /></h2>
            <svg  viewBox="0 0 32 40" width={80} >
          
                <polyline class="st0" points="3,8 16,16 29,8 " style={{fill:'none',stroke:'#000000',strokeWidth:2,strokeLinecap:'round',strokeLineJoin:'round',strokeMiterlimit:10}}/>
                <polyline class="st0" points="27,22 23,26 21,24 " style={{fill:'none',stroke:'rgb(22, 200, 100)',strokeWidth:2,strokeLinecap:'round',strokeLineJoin:'round',strokeMiterlimit:10}}/>
                <circle class="st0" cx="24" cy="24" r="7" style={{fill:'none',stroke:'rgb(22, 200, 100)',strokeWidth:2,strokeLinecap:'round',strokeLineJoin:'round',strokeMiterlimit:10}}/>
                <path class="st0" d="M17.1,25H7c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h18c2.2,0,4,1.8,4,4v12.1" style={{fill:'none',stroke:'#000000',strokeWidth:2,strokeLineJoin:'round',strokeMiterlimit:10}}/>
            </svg>
            <h5> <Lang w={"descrizione"} page={"doi_popup"} /></h5>
            <p className="emailDoi">{changedEmail ? changedEmail : props.contenuto.email}</p>
            <h5><strong><Lang w={"conferma"} page={"doi_popup"}/></strong></h5>
          
           
          <ul className="listaDoi">
            <h5> <Lang w={"importante"} page={"doi_popup"}/></h5>
                <li> <Lang w={"punto1"} page={"doi_popup"}/></li>
                <li> <Lang w={"punto3"} page={"doi_popup"} placeholders={{servizio:config.servizi[domain].title}}/></li>
                <li> <Lang w={"punto2"} page={"doi_popup"}/></li>
            </ul> 
            {formShow ? (<>
                <h5 className="sfondoContrasto"> <Lang w={"se_sbagliata"} page={"doi_popup"}/> </h5>
                 <form className={"formSignup"} onSubmit={handleSubmit(onSubmit)}>
                    <input type="email" name="email" {... register('email')}  data-attribute="email" placeholder={email}  className={formError.email && ("errorCardInput")}  onChange={(e) => handleInputChange(e)}></input>
                    {errore && (<p className='erroreSignup'>{errore}</p>)}
                    <input type="submit" value={bottoneForm} disabled={spinner}></input>
                    <Spinner/>
                </form>
                </>
            ) : (
               <p className="okMessage"> <i className="fa fa-check"></i> {msgOk}</p>
            )}
        
        </>) : 

        (<>
              <h2> <Lang w={"attiva_account"} page={"doi_popup"}/></h2>
            <svg  viewBox="0 0 32 40" width={80} >
                <g>
                <polyline fill="none" points="14,9 1,9 1,31    31,31 31,16  " stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
                <polyline fill="none" points="14,9 1,9 16,24    22,18  " stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
                <line fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="1" x2="12" y1="31" y2="20"/>
                <line fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="31" x2="20" y1="31" y2="20"/>
                <circle cx="24" cy="8" fill="none" r="7" stroke="#ff0606" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/>
                <line fill="none" stroke="#ff0606" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="24" x2="24" y1="10" y2="12"/>
                <line fill="none" stroke="#ff0606" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" x1="24" x2="24" y1="8" y2="4"/>
                </g>
            </svg>
            <h5> <Lang w={"indirizzo_inserito"} page={"doi_popup"}/></h5>
            <p className="emailDoi">{changedEmail ? changedEmail : props.contenuto.email}</p>
            <h5> <Lang w={"risulta_non_valido"} page={"doi_popup"}/></h5>
            <div className="separator-line"></div>
            <h5 className="sfondoContrasto"> <Lang w={"se_sbagliata"} page={"doi_popup"}/> </h5>
            {formShow ? (
                 <form className={"formSignup"} onSubmit={handleSubmit(onSubmit)}>
                    <input type="email" name="email" {... register('email')}  data-attribute="email" placeholder={email}  className={formError.email && ("errorCardInput")}  onChange={(e) => handleInputChange(e)}></input>
                    {errore && (<p className='erroreSignup'>{errore}</p>)}
                    <input type="submit" value={bottoneForm} disabled={spinner}></input>
                    <Spinner/>
                </form>
            ) : (
               <p className="okMessage"> <i className="fa fa-check"></i> {msgOk}</p>
            )}
           {/*} <ul className="listaDoi">
            <h5> <Lang w={"importante"} page={"doi_popup"}/></h5>
                <li> <Lang w={"punto1"} page={"doi_popup"}/></li>
                <li> <Lang w={"punto2"} page={"doi_popup"}/></li>
                <li> <Lang w={"punto3"} page={"doi_popup"} placeholders={{servizio:config.servizi[domain].title}}/></li>
            </ul> {*/}
        </>)}

          
        </>
    )
	
}